import { GoVerified } from 'react-icons/go';
import { useEffect, useState } from 'react';
import { ICommentSideModal } from '../../../interfaces/components/comment.interface';
import { TCommentVote } from '../../../interfaces/hook.interface';

interface ICommentCardVote {
  id: string;
  votes: string | number;
  isUpvoted?: boolean;
  parentId?: string;
  handleVoteGlobal: TCommentVote;
}

const CommentCardVote = ({
  isUpvoted,
  votes,
}: ICommentCardVote & ICommentSideModal) => {
  const [legitBtnClicked, setLegitBtnClicked] = useState(isUpvoted);

  useEffect(() => {
    setLegitBtnClicked(isUpvoted);
  }, [isUpvoted]);

  return (
    <div className="w-[36px] lg:w-[50px] text-gray-500 flex gap-2 items-center justify-center">
      <p className="font-normal text-sm flex justify-center items-center lg:inline-block">
        {votes}
      </p>
      <div
        className={`${legitBtnClicked ? 'text-[#4FA03B]' : 'text-gray-500'}`}
      >
        <GoVerified className={`w-5 h-5 `} />
      </div>
    </div>
  );
};

export default CommentCardVote;
